<template>
<div>
  <!-- Search -->
  <div class="row mt-4">
    <div class="col-md-8">
      <input
        class="input form-control"
        @keypress.enter="find()"
        v-model="query.generic"
        placeholder="Pesquisar por BackProcessId"
      >
      <search-icon @click="find()" class="icon icon-within"/>
    </div>
    
    <button
      class="col-md-1 ml-2 btn-sm btn-outline"
      :class="{ 'btn-outline-active': showFilter }"
      @click="showFilter = !showFilter"
    >
      <span>Filtros</span>
      <chevron-down-icon
        class="fa-angle-right"
        :class="{'rotate-90': showFilter }"
      />
    </button>
    
    <button v-if="changeQuery" @click="find()" class="btn btn-link">
      Aplicar filtros ({{ numberOfBadges }})
    </button>
  </div>
  
  <!-- Badges  -->
  <div class="row">
    <div class="col-md-12">
      <BadgeFilters
        :query="query"
        @clearBadge="find()"
        @clearAllBadges="find()"
        :amount-changed="updateNumberOfBadges"
        :filters="[
          filterAccount, filterStatus, filterStartDate, filterEndDate, filterCityCode
        ]"
      />
    </div>
  </div>
  
  <!-- Filters -->
  <template v-if="showFilter">
    <div class="row mt-4">
      <div class="col-md-4">
        <label id="consult-account-id">Contas</label>
        <Select2
          :options="filterAccount"
          v-model="query.accountId"
          id="consult-account-id"
          title-load="Carregando contas..."
        />
      </div>
      
      <div class="col-md-4">
        <label for="consult-status">Stauts</label>
        <Select2
          v-model="query.status"
          id="consult-status"
          :options="filterStatus"
        />
      </div>
      
      <div class="col-md-4">
        <label for="consult-city-code">Cidade</label>
        <Select2
          v-model="query.cityCode"
          id="consult-city-code"
          :options="filterCityCode"
        />
      </div>
    </div>
    
    <div class="row mt-4">
      <div class="col-md-6">
        <label for="consult-start-date">Data inicial</label>
        <input
          v-model="query.startDate"
          type="date"
          id="consult-start-date"
          class="form-control"
        >
      </div>
      
      <div class="col-md-6">
        <label for="consult-end-date">Data final</label>
        <input
          v-model="query.endDate"
          type="date"
          id="consult-end-date"
          class="form-control"
        >
      </div>
    </div>
  </template>
  <hr>
  
  <!-- Table -->
  <div class="row">
    <div class="col-sm-12">
      
      <div class="row mt-4">
        <div class="col-md-12">
          <strong class="mr-3">
            {{infoTotalModels}}
          </strong>
        </div>
      </div>
      
      <table class="table table-borderless table-align table-h51">
        <thead>
          <tr>
            <th>ID</th>
            <th>BackProcessId</th>
            <th>Status</th>
            <th>Cidade</th>
            <th>Conta</th>
            <th>Tomador</th>
            <th>Prestador</th>
            <th>Tentativas</th>
            <th>Data inicial</th>
            <th>Data final</th>
            <th>Criado em</th>
            <th>Atualizado em</th>
            <th>Detalhes</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="consult in consults" :key="consult.id">
            <td :class="buildClass(consult.status)">
              {{ consult.id }}
            </td>
            <td>{{ consult.backProcessId }}</td>
            <td>{{ `status.${consult.status}` | t }}</td>
            <td class="nowrap" :title="consult.cityCode">
              {{ consult.cityCode | cityHallName }}
            </td>
            <td>{{ getAccountName(consult) }}</td>
            <td>{{ consult.taker.cnpj | cnpj }}</td>
            <td>{{ consult.provider && consult.provider.cnpj | cnpj }}</td>
            <td>{{ consult.attempts }}</td>
            <td>{{ consult.startDate | date }}</td>
            <td>{{ consult.endDate | date }}</td>
            <td>{{ consult.createdAt | datetime }}</td>
            <td>{{ consult.updatedAt | datetime }}</td>
            <td>
              <button @click="showDetail(consult)" class="btn btn-outline">
                Detalhes
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div class="row">
        <div class="col-md-12 my-1">
          <Pagination
            v-model="meta.currentPage"
            :total-count="meta.totalCount"
            :total-pages="meta.totalPages"
            @pagination="pagination"
          />
        </div>
      </div>
    
    </div>
  </div>
  
  <!-- Modal -->
  <Modal v-if="currentConsult" v-model="showModal">
    <div slot="header">
      <h3>Detalhes</h3>
    </div>
    
    <div class="event-detail">
      <VueJsonPretty
        :data='currentConsult'
        :deep='2'
        :showLength='true'
        :showLine='true'
      />
    </div>
  </Modal>
</div>
</template>

<script>
import BadgeFilters from '@/components/shares/BadgeFilters'
import Pagination from '@/components/shares/specialTag/Pagination'
import Modal from '@/components/shares/specialTag/Modal'
import ModelMapper from '@/mixins/ModelMapper'
import Select2 from '@/components/shares/Select2'
import VueJsonPretty from 'vue-json-pretty'

import { ChevronDownIcon, SearchIcon } from 'vue-feather-icons'
import { Filter } from '@/models/filter'
import { IBGE } from '@/models/ibge'

import 'vue-json-pretty/lib/styles.css'

export default {
  components: {
    BadgeFilters,
    ChevronDownIcon,
    Modal,
    Pagination,
    SearchIcon,
    Select2,
    VueJsonPretty
  },
  computed: {
    consults() {
      return this.getModels || []
    }
  },
  created() {
    this.addOrderBy('createdAt')
    
    const date = new Date()
    date.setDate(date.getDate())
    
    this.$set(this.query, 'startDate', date.toISOString().substring(0, 10))
    // this.$set(this.query, 'important', '')
    // this.$set(this.query, 'type', '')
    
    this.defaultModelSetting.updateQueryURL = true
    this.filterAccount = this.buildFilterAccount(this.allAccounts.data)
    
    this.asyncTemplateSelect({
      byURL: true,
      pagination: true
    })
  },
  data: () => ({
    currentConsult: null,
    filterAccount: null,
    filterCityCode: new Filter({
      key: 'cityCode',
      label: 'Código',
      table: IBGE.table.map(city => ({
        label: `${city.name} - ${city.initials}`,
        value: city.cityCode
      }))
    }),
    filterEndDate: new Filter({
      key: 'endDate',
      label: 'Data final',
      type: 'date'
    }),
    filterStartDate: new Filter({
      key: 'startDate',
      label: 'Data inicial',
      type: 'date'
    }),
    filterStatus: new Filter({
      key: 'status',
      label: 'Status',
      table: [
        ['Aguardando', 'wait'],
        ['Processado', 'processed'],
        ['Rejeitado', 'rejected'],
        ['Erro', 'error']
      ]
    }),
    modelPathPrefix: 'admin/city_hall_mapper',
    nameModel: 'Consult',
    showModal: false,
  }),
  filters: {
    cityHallName(cityCode) {
      return IBGE.getByCityCode(cityCode, (city) => `${city.name} - ${city.initials}`)
    }
  },
  inject: ['allAccounts', 'buildFilterAccount', 'getAccountName'],
  methods: {
    buildClass(status) {
      const table = {
        processed: 'marker-green',
        wait: 'marker-yellow',
      }
      
      return table[status] || 'marker-red'
    },
    find() {
      this.asyncTemplateSelect()
    },
    showDetail(consult) {
      this.currentConsult = consult
      this.showModal = true
    }
  },
  mixins: [ModelMapper],
  name: 'Consult',
  watch: {
    allAccounts: {
      deep: true,
      handler(value) {
        this.filterAccount = this.buildFilterAccount(value.data)
      },
    }
  }
}
</script>

<style scoped>

.event-detail * {
  background: #051724;
  color: #FFF;
  padding: 16px;
  border-radius: 8px;
}

.rotate-90 {
  transform: rotate(180deg);
}

.fa-angle-right {
  transition: transform .2s;
  margin-left: 8px;
}

</style>